module.exports = __webpack_public_path__ + "img/42.7796ec27.svg";